/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Layout_SavedInputs */

const cs_messages_layout_saved = /** @type {(inputs: Messages_Layout_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozložení zpráv uloženo.`)
};

const en_messages_layout_saved = /** @type {(inputs: Messages_Layout_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message layout saved.`)
};

/**
* | output |
* | --- |
* | "Message layout saved." |
*
* @param {Messages_Layout_SavedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_layout_saved = /** @type {((inputs?: Messages_Layout_SavedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Layout_SavedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_layout_saved(inputs)
	return cs_messages_layout_saved(inputs)
});